"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  containerInfo: {
    title: '箱净重查询',
    containerNo: '箱号',
    tips_1: ' 温馨提示：',
    tips_2: '（1）请输入11位箱号,各箱号以逗号或换行符分隔（如：SITU1234567,SITU123123,DFSU456456）;',
    tips_3: '（2）查询结果仅供参考，实际皮重以该集装箱箱门上标明的为准;',
    containerType: '箱型',
    tareWeight: '箱净重（KG）',
    payloadWeight: '最大载重（KG）'
  }
};